// prevents angular change detection when clicked on document
$.blockUI.defaults.bindEvents = false; 
